import { Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ApiService } from 'app/api.service';
import { debounceTime, Subject } from 'rxjs';
import { PurchaseOrderFileModalComponent } from '../purchase-order-file-modal/purchase-order-file-modal.component';
import { PurchaseOrderArchiveComponent } from 'app/purchase-order-archive/purchase-order-archive.component';
import { ApprovalTimelineDialogComponent } from '../../../components/approval-timeline/approval-timeline-dialog.component';
import { ApprovalTimelineData } from '../../../components/approval-timeline/approval-timeline.component';
import { DocumentTracingModalComponent } from 'app/components/document-tracing-modal/document-tracing-modal.component';
import { forkJoin} from 'rxjs';
import { ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { ReOpenService } from 'app/reopen.service';
import { CancelApprovalService } from 'app/cancel-approval.service';
import { UiPanelAction, UiPanelMode, UiApprovalStep } from 'app/shared/ui/models/ui-document-panel.model';
import { UiBadgeVariant } from 'app/shared/ui/models/ui-badge.model';
import { UiUnsavedChangesDialogComponent, UnsavedChangesResult } from 'app/shared/ui/document-panel/ui-unsaved-changes-dialog/ui-unsaved-changes-dialog.component';
import { UI_DOCUMENT_PANEL_BREADCRUMBS } from 'app/shared/ui/document-panel/document-panel.config';

@Component({
  selector: 'app-purchase-order-dialog',
  templateUrl: './purchase-order-dialog.component.html',
  styleUrls: ['./purchase-order-dialog.component.scss'],
  host: { class: 'ui-document-panel-host' },
})
export class PurchaseOrderDialogComponent {
  quotation: any[];
  productList: any[] = [];
  date: string = '';
  po_no: any;
  vendor: any;
  branch:any;
  vendor_branch:any;
  selectedProducts: any[] = [];
  labels: any[] = [];
  flattenedLabels: any[] = [];
  selectedLabel: any;
  filteredQuotations = [];
  requisition_data=[];
  vendorid: any;
  maxDate: string = '';
  quotation_ids: any[] = [];
  requisition_ids: any[] = [];
  quotations: string = '';
  vendordata:any[]=[];
  selectedBranch:any;
  vendordetails:any;
  isUpdateMode:boolean= false;
  isView = false;
  panelMode: UiPanelMode = 'create';
  enteredEditFromView = false;
  editSnapshot: string | null = null;
  user_id: any;
  hostname: string;
  fullhostname: string;
  readonly breadcrumb = UI_DOCUMENT_PANEL_BREADCRUMBS.purchaseOrder; 
  amount:any[]=[];
  temp_amount:any[]=[];
  types:any;
  changeqty:any;
  changeprice:any;
  store_data: any[];
  store: any;
  profitcost:any
  profitCost_data:any[];
  private qtyChangeSubject = new Subject<{sublabel: any,qty:any,price:any,product:any }>();
  private priceChangeSubject = new Subject<{sublabel: any,qty:any,price:any }>();
  //selectedBranchName: string = '';
  selectedBranchId:any;
  is_requisition:boolean=true;//this will be false 
  is_qc:boolean=false; //this will be true
  requisition:any[];
  filteredRequisitions: any[] = []; 
  requisitions: string = '';
  image_data: any;
  file: File | null = null;
  // myFiles:string [] = [];
   myFiles: File[] = [];
  imageUrls: any[] = [];
  documentUrls: any[] = [];
  base64File:any[]=[] ;
  document_type:any;
  documentTypes = ['Goods','Services','Fixed Asset'];
  contact_type_id: any;
  contact_type:any;
  contactTypes: any[] = [];
  groupedContactPersons: any[];
  contact_person_id: number;
  section_data:any[];
  section_ids: any[] = [];
  sections: string = '';
  section: any[];
  skuIdProductsMap:any;
  branchdata: any[] = [];
  selectedstore:any;
  filteredProfitCost: any[] = [];
  remark:any;
  contactPersons: any[];
  selectedContactPersonId: null;
  contactPersonName: string;
  expected_delivery_date?: string; 
  catagorys: any[] = [];
  category_ids:any[]=[];
  calculated_budget: any = {};
  gstSummary: any[] = [];
  customerGstType:any;
  vendorGstType: any;
  vendorbranch: any;
  selectedVendorBranchId: any;
  is_reverse: boolean = false;
  reverseQtyChangeSubject = new Subject<{sublabel: any,product:any }>();
  previousBranch: any;
  previousProfitCost: any;
  previousSection: any;
  selectedbranch: any;
  previousStore: any;
  previousRequisition: any[] = [];
  vendorOffset = 0;
  vendorLimit = 100;
  vendorHasMore = true;
  loadingVendor = false;
  vendorSearch = '';
  branchOffset = 0;
  branchLimit = 100;
  branchHasMore = true;
  loadingBranch = false;
  branchSearch = '';
  is_approval_status:any;
  profitCostOffset = 0;
  profitCostLimit = 100;
  profitCostHasMore = true;
  loadingProfitCost = false;
profitCostSearch = '';
  @ViewChild('vendorSelect') vendorSelect!: MatSelect;
  @ViewChild('branchSelect') branchSelect!: MatSelect;
  private amountUpdateScheduled = false;
  get Object() {
    return Object;
  }
  constructor(
    private apiService: ApiService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<PurchaseOrderDialogComponent>,
    private reopenService: ReOpenService,
    private cancelApprovalService: CancelApprovalService,
    @Inject(MAT_DIALOG_DATA) public data: { id: any;rfq_ids:any;req_ids:any; types?: any;is_type?:any; contact_type_id?:any;approval_status?:any;profit_cost_id?:any;remark?:any ;short_close?:any}
  ) {
    const userString = localStorage.getItem('data');
    const user = JSON.parse(userString) || {};
    this.user_id = user?.id;
    this.types=data?.types;
    this.is_approval_status=data?.approval_status;
    this.is_short_close = data?.short_close == 1;
    console.log('data',this.data);
    console.log('type',this.types);
    if (data?.id) {
      if (this.types === 'reverse') {
        this.is_reverse = true;
      } else {
        this.is_reverse = false;
      }
      console.log('is_reverse:', this.is_reverse);
      this.isUpdateMode = true;
      this.apiService.getPoItem(data?.id).subscribe(
        (response) => {
          console.log('update payload',response);
          this.vendor = response.details[0].vendor_id;
          this.vendorBranch(this.vendor)
         // this.fetchStore();
           this.fetchBranchData();
          //this.fetchrequisition();
          this.po_no = response.details[0].po_no;
          if (this.data.approval_status === undefined || this.data.approval_status === null) {
            const fetchedStatus = response.details[0].approval_status ?? response?.approval_status ?? null;
            if (fetchedStatus !== undefined && fetchedStatus !== null) {
              this.data.approval_status = fetchedStatus;
              this.is_approval_status = fetchedStatus;
            }
          }
          const fetchedShortClose = response.details[0]?.short_close ?? response.details[0]?.is_short_close ?? response?.short_close ?? response?.is_short_close ?? this.data?.short_close ?? null;
          if (fetchedShortClose !== undefined && fetchedShortClose !== null) {
            this.data.short_close = fetchedShortClose;
            this.is_short_close = fetchedShortClose == 1;
          }
          this.vendor_branch = response.details[0].vendor_branch_id;
          this.selectedstore= response.details[0].store_id;
          console.log('selected store', this.selectedstore);
          this.branch = response.details[0].branch_id;
          this.previousBranch = this.branch;
          this.vendorDetails(this.vendor_branch);
          this.date = response.details[0].date;
         // this.store=response.details[0].store_id;
          this.document_type=response.details[0].document_type;
          // this.fetchProfitCost(this.branch);
          this.applyBranchChange(this.branch);
          this.profitcost=response.details[0].profit_cost_id;
          this.previousProfitCost = this.profitcost;
          console.log('profit center', this.profitcost);
          // this.fetchSection(this.profitcost);
          this.applyProfitCostChange(this.profitcost);
          this.store = this.selectedstore;
          this.previousStore = this.store;
          this.quotations = response.details[0].quotation_id;
          this.requisitions = response.details[0].requisition_id;
          this.contact_type_id= response.details[0].contact_type_id;
          this.fetchContactPersons(this.vendor, this.vendor_branch);
          // this.sections= response.details[0].section_id;
          // this.remark= response.details[0].remark;
          // const sectionIds = this.sections.split(',').map((id) => +id);
          this.sections = response.details[0].section_id;
          const sectionIds = this.sections ? this.sections.split(',').map((id) => +id) : [];
          this.section = sectionIds;
          this.previousSection = sectionIds;
          this.remark = response.details[0].remark;          // this.selectedBranchName = response.details[0].vendor_branch.branch_name ??'';
           this.selectedBranchId = response.details[0].vendor_branch_id??'';
          if (this.data?.is_type==1) {
            this.vendorData();
            this.fetchqc(this.vendor,this.selectedBranchId);
            console.log('under qc');
            this.is_qc = true;
            this.is_requisition = false;
            const postData = {
              rfq_ids: this.data?.rfq_ids,
              vendor_id: this.vendor
            };
            this.apiService.QuoteComparisiondetails(postData).subscribe(
              (response) => {
                this.productList = response;
                console.log('itemss update',this.productList);
              },
              (error) => {
                console.error('Error fetching data:', error);
              }
            );
          } else if(this.data?.is_type==2) 
          {
            this.fetchVendor();
            // this.fetchrequisition(this.selectedstore,this.profitcost,sectionIds);
            this.applySectionChange(this.previousSection);
            console.log('under requisition');
            this.is_qc = false;
            this.is_requisition = true;
            const postData = {
              requisition_ids: this.data?.req_ids,
            };
            this.apiService.getRequisitions(postData).subscribe(
              (response) => {
                this.productList = response;
                console.log('requisition products',this.productList);
              },
              (error) => {
                console.error('Error fetching data:', error);
              }
            );
          }
          this.labels = response.payload;
          const skuIdProductsMap: { [key: number]: any } = {};
          function validSku(labels: any[]) {
            labels.forEach(label => {
              if (label.subLabels && label.subLabels.length > 0) {
                label.subLabels.forEach(sub => {
                  sub.products?.forEach((product: any) => {
                    const existing = skuIdProductsMap[product.sku_id];
                    if (existing) {
                      existing.qty = (existing.qty || 0) + (product.qty || 0);
                    } else {
                      skuIdProductsMap[product.sku_id] = { ...product };
                    }
                  });
                  if (sub.subLabels && sub.subLabels.length > 0) {
                    validSku(sub.subLabels);
                  }
                });
              }
            });
          }
          forkJoin([
            this.apiService.getbranch(this.vendor),
            this.apiService.getDatabranch(),
          ]).subscribe(
            ([vendorBranches, branches]) => {
              this.vendorbranch = vendorBranches?.data ?? [];
              this.branchdata = branches ?? [];
              this.gstMatch();
              this.labels = response.payload;
              this.flattenLabels();
              this.calculateGSTTotals();
            },
            (error) => {
              console.error("Error fetching data:", error);
            }
          );

          validSku(this.labels);
          this.skuIdProductsMap = skuIdProductsMap;
          console.log('filtered sku', this.skuIdProductsMap);

          const result = this.extractLevels(this.labels);
          console.log(result);
          console.log('update labels',this.labels);
          this.flattenLabels();
          //this.fetchContactPersonData();
        },
        (error) => {
          console.error('Error fetching data:', error);
        }
      );
    }

    const scheduleAmountUpdate = () => {
      if (this.amountUpdateScheduled) return;
      this.amountUpdateScheduled = true;
      Promise.resolve().then(() => {
        this.amountUpdateScheduled = false;
        this.onAmountUpdated([]);
      });
    };
    const originalPush = this.amount.push;
    const originalSplice = this.amount.splice;
    this.amount.push = (...items: any[]) => {
      const result = originalPush.apply(this.amount, items);
      scheduleAmountUpdate();
      return result;
    };

    this.amount.splice = (start: number, deleteCount?: number, ...items: any[]) => {
      // @ts-ignore - keep same runtime behavior as native splice
      const result = originalSplice.apply(this.amount, [start, deleteCount, ...items]);
      scheduleAmountUpdate();
      return result;
    };
     this.qtyChangeSubject.pipe(debounceTime(1000)).subscribe(({ sublabel,qty,price }) => {
          console.log('Labels:', this.labels);
          console.log('Sub Label:', sublabel);
          console.log('Sub qty:', qty);
          console.log('Sub price:', price);
          this.changeqty=qty
          this.changeprice=price
          this.updateLabels(this.labels, sublabel);
        });

    this.priceChangeSubject.pipe(debounceTime(1000)).subscribe(({ sublabel,qty,price }) => {
          console.log('Labels:', this.labels);
          console.log('Sub Label:', sublabel);
          console.log('Sub qty:', qty);
          console.log('Sub price:', price);
          this.changeqty=qty
          this.changeprice=price
          this.updateLabels(this.labels, sublabel);
        });  
                
    this.reverseQtyChangeSubject.pipe(debounceTime(1000)).subscribe(({ sublabel, product }) => {
      // console.log('product 111', product);
      // console.log('sublabel 111', sublabel);
      // store original qty only once
      if (product.original_qty === undefined) {
        product.original_qty = Number(product.qty || 0);
      }

      let reverse_qty = Number(product.reverse_qty || 0);
      const original_qty = Number(product.original_qty || 0);
      if (reverse_qty > original_qty) {
        alert(`Reverse quantity cannot be greater than original quantity ${original_qty}`);
        product.reverse_qty = 0;
        reverse_qty = 0;
        return;
      }
      //console.log('product', product);
      if (product.reverse_qty > product.remaining_qty) {
        alert(`Reverse quantity cannot be greater than Remaining quantity ${product.remaining_qty}`);
        product.reverse_qty = 0;
        reverse_qty = 0;
        return;
      }
      const price = Number(product.unit_price || 0);
      // always subtract from original qty
      const changeqty = original_qty - reverse_qty;
      product.total_qty = changeqty > 0 ? changeqty : 0;
      this.changeqty = changeqty;
      this.changeprice = price;
      this.updateLabels(this.labels, sublabel);
      });

    this.initPanelMode();
   }
  updateLabels(labels: any[], slabels: any): any[] {
    console.log('slevel', slabels.level);
    return labels.map(label => {
      if (label.subLabels) {
        const index = label.subLabels.findIndex(subLabel => subLabel.label === slabels.label);
        console.log('index', index);
        console.log('remove sublevel', label.subLabels[index])
        if (index !== -1) {
          console.log("Removed subLabel:", label.subLabels[index]);
          label.subLabels.splice(index, 1, slabels);
          const index1 = this.amount.findIndex(aLabel => aLabel.level === slabels.label);

          if (index1 !== -1) {
            console.log('inside amont push');
            this.amount.splice(index1, 1);
            this.amount.push({ level: slabels.label, amount: this.changeqty * this.changeprice, start_date: slabels?.start_date, end_date: slabels?.end_date })
            console.log('after amount push', this.amount);
          }
          console.log("Updated subLabels:", label.subLabels);
          this.calculateGSTTotals();
        } else {
          label.subLabels = this.updateLabels(label.subLabels, slabels);
        }
      }
      return label;
    });
  }
  
  onQtyChange(sublabel: any, qty: any, price: any, product: any) {
    this.qtyChangeSubject.next({ sublabel, qty, price, product });
  }

  onPriceChange(sublabel: any, qty: any, price: any) {
    this.priceChangeSubject.next({ sublabel, qty, price });
  }
  onReverseQtyChange(sublabel: any, product: any) {
    // console.log('product 111', product);
    // console.log('sublabel 111', sublabel);
    // // store original qty only once
    // if (product.original_qty === undefined) {
    //   product.original_qty = Number(product.qty || 0);
    // }

    // let reverse_qty = Number(product.reverse_qty || 0);
    // const original_qty = Number(product.original_qty || 0);
    // if (reverse_qty > original_qty) {
    //   alert(`Reverse quantity cannot be greater than original quantity ${original_qty}`);
    //   product.reverse_qty = 0;
    //   reverse_qty = 0;
    //   return;
    // }
    // //console.log('product', product);
    // if (product.reverse_qty > product.remaining_qty) {
    //   alert(`Reverse quantity cannot be greater than Remaining quantity ${product.remaining_qty}`);
    //   product.reverse_qty = 0;
    //   reverse_qty = 0;
    //   return;
    // }


    // const price = Number(product.unit_price || 0);

    // // always subtract from original qty
    // const changeqty = original_qty - reverse_qty;

    // product.total_qty = changeqty > 0 ? changeqty : 0;

    this.reverseQtyChangeSubject.next({sublabel,product});
  }

  extractLevels(data: any[]): any[] {
    let extractedData: any[] = [];

    const traverse = (node: any) => {
      if (node.products && node.products.length > 0) {
        const extractedItem = {
          level: node.label,
          amount: node.products[0].price,
          start_date: node.products[0].start_date,
          end_date: node.products[0].end_date
        };
        extractedData.push(extractedItem);
        this.amount.push(extractedItem);
      }

      if (node.subLabels && node.subLabels.length > 0) {
        node.subLabels.forEach(subLabel => traverse(subLabel));
      }
    };

    data.forEach(item => traverse(item));

    return extractedData;
  }

// fetchContactPersonData() {
//   this.apiService.getContact().subscribe(
//     (response: any[]) => {
//       // Group contacts by their contact_type
//       const grouped: any[] = [];
//       const companyContacts = response.filter(c => c.contact_type === 'Company Contact person');
//       if (companyContacts.length) {
//         grouped.push({
//           contact_type: 'Company Contact person',
//           items: companyContacts
//         });
//       }

//       const customerVendorContacts = response.filter(c => c.contact_type === 'Customer/Vendor Contact Person');
//       if (customerVendorContacts.length) {
//         grouped.push({
//           contact_type: 'Customer/Vendor Contact Person',
//           items: customerVendorContacts
//         });
//       }

//       this.groupedContactPersons = grouped;
//       console.log("Grouped Contacts:", this.groupedContactPersons);
//     },
//     (error) => {
//       console.error('Error fetching contact data:', error);
//     }
//   );
// }
  ngOnInit(): void {
    this.hostname = window.location.hostname;
    this.fullhostname = window.location.origin;
    const today = new Date();
    this.date = this.formatDate(today);
    this.maxDate = this.formatDate(today);
    //this.fetchrequisition();
    if (this.is_qc) {
      this.vendorData();
    }else if(this.is_requisition){
      this.fetchVendor();
      //this.fetchStore()
      //this.fetchrequisition(this.store);
    }
    //this. fetchContactPersonData();
    this.fetchBranchData();
    if (this.panelMode === 'edit') {
      this.editSnapshot = this.captureEditSnapshot();
    }
    }

  formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  fetchqc(vendor_id: any,branch_id:any) {
    console.log('vendor_id',vendor_id);
    console.log('branch_id',branch_id);
    this.productList=[];
    this.filteredQuotations=[];
    this.vendorid = vendor_id;
    this.selectedBranchId = branch_id;
    // if (!this.data?.id) {
    // const selectedVendor = this.vendordata.find(item => item.vendor_id === vendor_id);
    // this.selectedBranchName = selectedVendor ? selectedVendor.vendor_branch_name : '';
    // this.selectedBranchId = selectedVendor ? selectedVendor.vendor_branch_id : '';
    // }
    console.log('vendor id ',this.vendorid)
    const postData = {
      vendor_id: this.vendorid,
      branch_id:branch_id
    };
    this.vendorDetails(branch_id);
    this.apiService.getQc(postData).subscribe(
      (response) => {
        this.filteredQuotations = response;

        console.log('filtered quotations',this.filteredQuotations);
        if (this.data?.id) {
          this.setSelectedQuotations(this.quotations);
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

fetchContactPersons(vendor_id: any, branch_id: any) {
  this.vendorid = vendor_id;
  this.selectedBranchId = branch_id;
    this.contactPersons = [];

  this.apiService.getContactsByVendorBranch(vendor_id, branch_id).subscribe(
    (contacts: any[]) => {
      this.contactPersons = contacts || [];
      if (this.data?.id) {
        // this.selectedContactPersonId = this.contactPersons.find(c => c.contact_person_id)?.contact_person_id || null;
        this.selectedContactPersonId = this.contact_type_id;
      }
    },
    () => {
      this.contactPersons = [];
      this.selectedContactPersonId = null;
    }
  );
}


  // fetchrequisition(store_id:any,profitcost:any,section_id:any) {
  //   this.requisition=[];
  //   this.productList=[];
  //   this.labels=[];
  //   this.vendorid=this.vendor;
  //   this.section_ids=section_id;
  //   const postData = {
  //     store_id: store_id,
  //     profit_cost_id:profitcost,
  //     section_id:section_id
  //   };
  //   this.apiService.getStoreRequisition(postData).subscribe(
  //     (response) => {
  //       this.requisition_data = response;
  //       console.log('all requisition data',this.requisition_data);
       
  //       if (this.data?.id) {
  //         this.filteredRequisitions = this.requisition_data.filter(item => item.is_po === 1);
  //         this.setSelectedRequisitions(this.requisitions);
  //       }else{
  //         // this.filteredRequisitions = this.requisition_data.filter(item => item.is_po === 0);
  //         this.filteredRequisitions = this.requisition_data.filter(item => item.is_po === 0 || item.is_po === 1);

  //       }
  //       console.log('filtered requision',this.filteredRequisitions);
  //     },
  //     (error) => {
  //       console.error('Error fetching data:', error);
  //     }
  //   );
  // }
  onSectionChange(section_id: any) {
    if (this.previousSection === null || this.previousSection === undefined) {
      this.previousSection = section_id;
      this.applySectionChange(section_id);
      return;
    }

    if (JSON.stringify(this.previousSection) === JSON.stringify(section_id)) {
      return;
    }

    const removedSections = this.previousSection.filter(x => !section_id.includes(x));

    // Determine if we are losing any "work" (labels or selected requisitions)
    const hasAddedItems = this.hasItemsFromSections(this.labels, removedSections);
    const hasSelectedReqs = this.hasReqsFromSections(this.requisition, removedSections);

    const willLoseData = removedSections.length > 0 && (hasAddedItems || hasSelectedReqs);

    if (willLoseData) {
      if (this.isUpdateMode && this.data?.approval_status === 'Open') {
        const skuIds = this.productList?.map((p: any) => p.sku_id?.id || p.sku_id).filter(Boolean) || [];

        this.apiService.checkNextDocument({
          doc_id: this.data.id,
          model: 'PurchaseOrder',
          sku_id: skuIds
        }).subscribe((res: any) => {
          if (res.status === false) {
            alert('Next document created. Cannot change branch.');
            this.revertSection();
          } else {
            this.confirmSectionAndProceed(section_id);
          }
        });
      } else {
        this.confirmSectionAndProceed(section_id);
      }
    } else {
      // 🔹 EASY PATH: Addition or Removal of "empty" sections
      this.previousSection = section_id;
      // When adding or removing unaffected sections, we don't need to wipe current products
      this.applySectionChange(section_id, false);
    }
  }

  // Recursive check: Does the labels list have products from these sections?
  private hasItemsFromSections(labels: any[], sectionIds: any[]): boolean {
    if (!labels || labels.length === 0) return false;
    for (const label of labels) {
      if (label.products && label.products.length > 0) {
        for (const p of label.products) {
          if (sectionIds.includes(Number(p.section_id))) return true;
        }
      }
      if (label.subLabels && this.hasItemsFromSections(label.subLabels, sectionIds)) {
        return true;
      }
    }
    return false;
  }

  // Check: Does the selected requisition list have requisitions from these sections?
  private hasReqsFromSections(selectedReqs: any[], sectionIds: any[]): boolean {
    if (!selectedReqs || selectedReqs.length === 0) return false;
    return selectedReqs.some(req => sectionIds.includes(Number(req.section_id)));
  }
  confirmSectionAndProceed(section_id: any[]) {
    console.log('Confirm and proceed', section_id);
    const confirmed = confirm(
      'Changing Section will clear selected section, store, requisition and products. Do you want to continue?'
    );

    if (!confirmed) {
      this.revertSection();
      return;
    }

    this.previousSection = section_id;
    this.applySectionChange(section_id);
  }
  applySectionChange(section_id: any[], clearCurrentData: boolean = true) {
    if (clearCurrentData) {
      this.resetSectionDependentData();
    }
    this.vendorid = this.vendor;
    this.section_ids = section_id;
    const postData = {
      store_id: this.store,
      profit_cost_id: this.profitcost,
      section_id: section_id
    };
    this.apiService.getStoreRequisition(postData).subscribe(
      (response) => {
        this.requisition_data = response;
        console.log('all requisition data', this.requisition_data);

        if (this.data?.id) {
          this.filteredRequisitions = this.requisition_data.filter(item => item.is_po === 1);
          this.setSelectedRequisitions(this.requisitions);
        } else {
          this.filteredRequisitions = this.requisition_data.filter(item => item.is_po === 0 || item.is_po === 1);
        }
        console.log('filtered requision', this.filteredRequisitions);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  resetSectionDependentData() {
    this.requisition = [];
    this.productList = [];
    this.labels = [];
    this.vendorid = this.vendor;
    this.section_ids = this.section;
  }

  revertSection() {
    setTimeout(() => {
      this.section = this.previousSection;
    });
  }
  requisitiondetials(selectedRequisition: any[]) {

    if (!this.previousRequisition) {
      this.previousRequisition = [];
    }

    if (JSON.stringify(this.previousRequisition) === JSON.stringify(selectedRequisition)) {
      return;
    }

    const removedReqs = this.previousRequisition.filter(
      oldReq => !selectedRequisition.some(newReq => newReq.id === oldReq.id)
    );

    const hasWorkLost = this.hasItemsFromRequisitions(this.labels, removedReqs.map(r => r.id));

    const proceedChange = () => {
      if (hasWorkLost) {
        if (!confirm('Deselecting Requisition(s) will clear associated items from the PO labels. Do you want to continue?')) {
          this.revertRequisition();
          return;
        }
      }
      // Success Path
      this.previousRequisition = [...selectedRequisition];
      this.applyRequisitionDetailsChange(selectedRequisition, hasWorkLost);
    };

    if (hasWorkLost && this.isUpdateMode && this.data?.approval_status === 'Open') {
      const skuIds = this.productList?.map((p: any) => p.sku_id?.id || p.sku_id).filter(Boolean) || [];
      this.apiService.checkNextDocument({
        doc_id: this.data.id,
        model: 'PurchaseOrder',
        sku_id: skuIds
      }).subscribe((res: any) => {
        if (res.status === false) {
          alert(res.message || 'Next document created. Cannot remove selected requisitions.');
          this.revertRequisition();
        } else {
          proceedChange();
        }
      });
    } else {
      proceedChange();
    }
  }

  private hasItemsFromRequisitions(labels: any[], reqIds: any[]): boolean {
    if (!labels || labels.length === 0) return false;
    for (const label of labels) {
      if (label.products && label.products.length > 0) {
        for (const p of label.products) {
          if (reqIds.includes(Number(p.requisition_id))) return true;
        }
      }
      if (label.subLabels && this.hasItemsFromRequisitions(label.subLabels, reqIds)) {
        return true;
      }
    }
    return false;
  }

  revertRequisition() {
    setTimeout(() => {
      this.requisition = [...this.previousRequisition];
    });
  }

  private applyRequisitionDetailsChange(selectedRequisition: any[], clearLabels: boolean) {
    if (clearLabels) {
      this.labels = [];
    }
    const requisition_ids = selectedRequisition.map(item => item.id);
    this.requisition_ids = requisition_ids;
    const postData = {
      requisition_ids: requisition_ids,
    };
    this.apiService.getRequisitions(postData).subscribe(
      (response) => {
        this.productList = response;
        console.log('requisition products',this.productList);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  setSelectedQuotations(quotationIds: string) {
    const selectedIds = quotationIds.split(',').map((id) => +id);
    this.quotation_ids = selectedIds,
    this.quotation = this.filteredQuotations.filter((item) => selectedIds.includes(item.id));
  }
  setSelectedRequisitions(requisitionIds: string) {
    const selectedIds = requisitionIds ? requisitionIds.split(',').map((id) => +id) : [];
    this.requisition_ids = selectedIds,
    console.log('reqids',this.requisition_ids);
    this.requisition = this.filteredRequisitions.filter((item) => selectedIds.includes(item.id));
    this.previousRequisition = [...this.requisition];
  }
  fetchdata(selectedItem: any[]) {
   // this.fetchPoNo();
    const quotationids = selectedItem.map(item => item.id);
    const rfqIds = selectedItem.map(item => item.rfq_id);
    this.quotation_ids = quotationids
    const postData = {
      rfq_ids: rfqIds,
      vendor_id: this.vendorid
    };
    this.apiService.QuoteComparisiondetails(postData).subscribe(
      (response) => {
        this.productList = response;
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  // fetchPoNo() {
  //   this.apiService.getPoNo().subscribe(
  //     (response) => {
  //       this.po_no = response.po_no;
  //     },
  //     (error) => {
  //       console.error('Error fetching data:', error);
  //     }
  //   );
  // }

  toggleSelection(detail: any) {
    detail.selected = !detail.selected;
  }
  
  detail() {
    // const selectedProducts = this.productList
    //   .flatMap((product: any) => product.quotationcomparisiondetials)
    //   .filter((detail: any) => detail.selected);

    const selectedProducts = this.is_qc
      ? this.productList
        .flatMap((product: any) => product.quotationcomparisiondetials)
        .filter((detail: any) => detail.selected)
      : this.productList
        .flatMap((product: any) => product.requisitiondetials)
        .filter((detail: any) => detail.selected);

    console.log('Products being added:', selectedProducts);
     if (!selectedProducts || selectedProducts.length === 0) {
        alert('Please select product.');
        return false;
      }
      if (this.selectedLabel == undefined) {
        alert('Please select a label.');
        return false;
      }
     if (!this.selectedLabel) {
      selectedProducts.forEach((product) => {
        console.log('productsss', product);
        product.unit_price = product.price;
        //product.last_valid_qty = product.total_qty;
        const newLabel = `${this.labels.length + 1}`;
        if(product.unit_price && product.total_qty && product.expected_delivery_date){
        this.labels.push({ label: newLabel, products: [product], subLabels: [], level: this.labels.length + 1, type: `header`});
        this.amount.push({ level: newLabel, amount: product.price * product.total_qty,start_date:product?.start_date,end_date:product?.end_date })
        console.log('product_label', this.labels);
        console.log('product_amount', this.amount);
        product.selected = false;
        } else {
          if (product.unit_price === undefined || product.unit_price === null || product.unit_price === '') {
            alert(`Unit Price is required for item:${product.item_service_type === 'SKU' ? product?.stock_keeping?.sku_name : product?.service?.service_name}`);
          }
          else if (product.total_qty === undefined || product.total_qty === null || product.total_qty === '') {
            alert(`Quantity for PO is required for item:${product.item_service_type === 'SKU' ? product?.stock_keeping?.sku_name : product?.service?.service_name}`);
          } else if (product.expected_delivery_date === undefined || product.expected_delivery_date === null || product.expected_delivery_date === '') {
            alert(`Expected Delivery Date is required for item:${product.item_service_type === 'SKU' ? product?.stock_keeping?.sku_name : product?.service?.service_name}`);
          }

        }
      });
    } else {
      this.addDetail(this.labels, this.selectedLabel, selectedProducts);
    }
    this.flattenLabels();
    this.calculateGSTTotals();
    this.selectedLabel = null;
  }

  addDetail(labels: any[], targetLabel: string, products: any[]) {
    for (const label of labels) {
      if (label.level === targetLabel) {
        products.forEach((product, index) => {
          if (product.item_service_type === 'Fixed Asset' && !product.total_qty) {
            product.total_qty = 1;
            console.log('fa total qty', product.total_qty);
          }
          product.unit_price = product.price;
          // product.last_valid_qty = product.total_qty;
          const newSubLabel = `${label.label}.${label.subLabels.length + 1}`;
          if(product.unit_price && product.total_qty && product.expected_delivery_date){
          label.subLabels.push({ label: newSubLabel, products: [product], subLabels: [], level: `${label.label}.${label.subLabels.length + 1}`, type: `header`});
          this.amount.push({ level: newSubLabel, amount: product.price * product.total_qty,start_date:product?.start_date,end_date:product?.end_date })
          console.log('subproduct_label', label.subLabels);
          console.log('subproduct_amount', this.amount);
          product.selected = false;
          this.calculateGSTTotals();
          } else {
            if (product.unit_price === undefined || product.unit_price === null || product.unit_price === '') {
              alert(`Unit Price is required for item:${product.item_service_type === 'SKU' ? product?.stock_keeping?.sku_name : product?.service?.service_name}`);
            }
            else if (product.total_qty === undefined || product.total_qty === null || product.total_qty === '') {
              alert(`Quantity for PO is required for item:${product.item_service_type === 'SKU' ? product?.stock_keeping?.sku_name : product?.service?.service_name}`);
            } else if (product.expected_delivery_date === undefined || product.expected_delivery_date === null || product.expected_delivery_date === '') {
            alert(`Expected Delivery Date is required for item:${product.item_service_type === 'SKU' ? product?.stock_keeping?.sku_name : product?.service?.service_name}`);
          } 
          }
        });
        return;
      }
      if (label.subLabels && label.subLabels.length > 0) {
        this.addDetail(label.subLabels, targetLabel, products);
      }
    }
  }

  flattenLabels() {
    const result: any[] = [];
    const recursiveFlatten = (labels: any[], parentLabel = '') => {
      for (const label of labels) {
        if(label.type=='item'){
        result.push(label.level);
        }
        if (label.subLabels && label.subLabels.length > 0) {
          recursiveFlatten(label.subLabels, label.level);
        }
      }
    };
    recursiveFlatten(this.labels);
    this.flattenedLabels = result;
    console.log('all level', this.flattenedLabels);
  }
  save(exitAfterSave: 'close' | 'view' = 'view') {
    console.log('all labels of save ',this.labels);
    if (!this.vendor) {
      alert('Please select Vendor');
      return;
    }
    else if (!this.vendor_branch) {
      alert('Please select Vendor Branch');
      return;
    }
    else if (!this.branch) {
      alert('Please select Branch');
      return;
    }
    else if (!this.profitcost) {
      alert('Please select Profit/Cost Center');
      return;
    }
    else if (!this.section) {
      alert('Please select Section');
      return;
    }
    else if (!this.quotation && this.is_qc) {
      alert('Please select Quotation');
      return;
    }
    else if (!this.requisition && this.is_requisition) {
      alert('Please select Requisition');
      return;
    }
    else if (!this.document_type) {
      alert('Please select Document Type');
      return;
    }
    else if (!this.date) {
      alert('Please fill Date');
      return;
    }
    else if (this.document_type =='Goods' && !this.store) {
      alert('Please select Store');
      return;
    }
    const mapAllProducts = (labels: any[]) => {
      console.log('labelss', labels);
      let allProducts: any[] = [];

      labels.forEach((label) => {
        const labelProducts = (label.products.length > 0
          ? label.products.map((product) => ({
            sku_id: product.sku_id || "",
            description: product.description || "",
            specification: product.specification || "",
            qty: product.total_qty || 0,
            unit: product.unit_id || 0,
            price: product.price || 0,
            hsn_no: product.hsn_no || "",
            start_date: product.start_date || "",
            end_date: product.end_date || "",
            expected_delivery_date: product.expected_delivery_date || "",
            label: label.label || "",
            labelDescription: label.description || "",
            type:label.type || "",
            unit_price:product.unit_price ||"",
            requisition_id:product.requisition_id ||"",
            quatation_comparision_id:product.quatation_comparision_id ||"",
            item_service_type:product.item_service_type || "",
            section_id:product.section_id || "",
            gst_percentage: product.gst_percentage, 
            requisition_details_id:this.data?.id ? product.requisition_details_id : product.id,
            remaning_qty:product.remaining_qty || 0,
            reverse_qty:product.reverse_qty || 0,
            reopen_qty:product.qty || 0
          }))
          : [
            {
              sku_id: "",
              description: "",
              specification: "",
              qty: 0,
              unit: 0,
              price: 0,
              hsn_no: "",
              start_date: "",
              end_date: "",
              expected_delivery_date: "",
              label: label.label || "",
              labelDescription: label.description || "",
              type:label.type || "",
              unit_price:"",
              requisition_id:"",
              quatation_comparision_id:"",
              item_service_type:label.item_service_type || "",
              section_id:"",
              gst_percentage: null,
              requisition_details_id:"",
              reverse_qty:0,
              reopen_qty:0
            },
          ]);

        allProducts = allProducts.concat(labelProducts);

        if (label.subLabels && label.subLabels.length > 0) {
          const subLabelProducts = mapAllProducts(label.subLabels);
          allProducts = allProducts.concat(subLabelProducts);
        }
      });

      return allProducts;
    };
  
    const payload = {
      vendor_id: this.vendorid,
      vendor_branch_id: this.selectedBranchId,
      quotation: this.quotation_ids,
      requisition: this.requisition_ids,
      po_no: this.po_no || null,
      date: this.date,
      type:this.types??'',
      is_type:this.quotation_ids?.length ? 1 : 2,
      selectedProducts: mapAllProducts(this.labels),
      // uploaded_files: this.base64File.map(file => file.file),
      uploaded_files: this.base64File, 
      store_id:this.store??'',
      profit_cost_id:this.profitcost??'',
      document_type: this.document_type??'',
      section:this.section_ids??'',
      branch_id:this.branch,
      remark:this.remark,
      contact_type_id: this.selectedContactPersonId,
      // expected_delivery_date: this.expected_delivery_date || "",
      doc_type:'PurchaseOrder',
    };

    console.log('Final Payload:', payload);
  //  return;
    const hasHeaderProduct = payload.selectedProducts.some((product: any) => product.type === 'header');
    if (!payload.selectedProducts || payload.selectedProducts.length === 0 || !hasHeaderProduct) {
      alert("Please add at least one item/service.");
      return;
    }
    if(this.data?.id){
      if(this.types === 'reopen'){
        const postData = {
          doc_id: this.data?.id,
          model: 'PurchaseOrder',
        };
        this.apiService.checkNextDocument(postData).subscribe({
          next: (res: any) => {
            // alert(res.message);
            // if (onSuccess) {
            //   onSuccess();
            // }
          },
          error: () => {
            alert('Something went wrong!');
          }
        });
      }
      this.apiService.updatepo(this.data?.id,payload).subscribe(
        (response: any) => {
          if (response?.status === true) {
            alert(response?.message);

            if (exitAfterSave === 'close') {
              this.dialogRef.close({
                id: response.po_id,
                action: 'update'
              });
            } else {
              this.enterViewMode();
            }

          } else {
            const errorMessage = response?.message || 'Failed to update purchase orders';
            console.log('Error message:', errorMessage);
            alert(errorMessage);
          }
        },
        (error) => {
          console.error('Error saving data:', error);
          const errorMsg = error?.error?.message || 'Failed to save purchase order. Please try again.';
          alert(errorMsg);
        }
      );

    } else {
      this.apiService.createpo(payload).subscribe(
        (response: any) => {
          console.log('Purchase order created', response);

          if (response?.status === true) {
            alert(response?.message);

            // close dialog AFTER alert
            this.dialogRef.close({
              id: response.po_id,   // <-- Use po_id based on your response
              action: 'create'
            });

          } else {
            alert(response?.message || 'Something went wrong!');
          }
        },
        (error: any) => {
          console.error('Error saving data:', error);
          const msg = error?.error?.message || 'Failed to save purchase order. Please try again.';
          alert(msg);
        }
      );
    }

  }

  deleteLabelAndProducts(label: any): void {
    console.log('label',label);
    const recursiveDelete = (labels: any[], targetLabel: any) => {
      for (let i = 0; i < labels.length; i++) {
        if (labels[i] === targetLabel) {
          labels.splice(i, 1);

          // for (let i = this.amount.length - 1; i >= 0; i--) {
          //   const level = this.amount[i]?.level;
          //   if (level === label.level || (typeof level === 'string' && level.startsWith(label.level + '.'))) {
          //     this.amount.splice(i, 1);
          //   }
          // }


          return true;
        }
        if (labels[i].subLabels && labels[i].subLabels.length > 0) {
          const foundAndDeleted = recursiveDelete(labels[i].subLabels, targetLabel);
          if (foundAndDeleted) return true;
        }
      }
      return false;
    };
    recursiveDelete(this.labels, label);
    this.on_delete_amount(label.level);
    this.update_array(this.labels, label)
    this.updateSelectedProducts();
    this.flattenLabels();
    this.calculateGSTTotals();
  }

  update_array(labels: any[], targetLabel: any): void {
    this.updateLevels(this.amount,targetLabel);
    let counter = 0;
    const recursiveUpdate = (labels: any[], targetLevel: number): void => {
      counter++;
      for (let i = 0; i < labels.length; i++) {
        if (this.check_string(labels[i].level) > targetLevel) {
          const _decreased_level = this.decreaseLevel(labels[i].level);
          labels[i].level = _decreased_level;
          labels[i].label = _decreased_level;
          if (labels[i].subLabels && labels[i].subLabels.length > 0) {
            recursiveUpdate(labels[i].subLabels, targetLevel);
          }
        }
      }
    };
    recursiveUpdate(labels, targetLabel.level);
    console.log(labels, "Updated labels");
    console.log(targetLabel, "Target label");
  }

  decreaseLevel(level) {
    if (typeof level !== 'string') {
      console.error("Input should be a string.");
      return level - 1;
    }
    if (level.includes('.')) {
      const parts = level.split('.');
      const firstPart = parseInt(parts[0], 10) - 1;
      if (firstPart < 1) {
        console.warn("The first segment cannot be less than 1.");
        return level;
      }
      parts[0] = firstPart.toString();
      return parts.join('.');
    } else {
      const num = parseInt(level, 10);
      if (num <= 1) {
        console.warn("Cannot decrease further, level is already at 1.");
        return level;
      }
      return (num - 1).toString();
    }
  }

  check_string(level) {
    if (typeof level !== 'string') {
      console.error("Input should be a string.");
      return level;
    }
    if (level.includes('.')) {
      const parts = level.split('.');
      var firstPart = parseInt(parts[0], 10);
    }
    return firstPart;
  }

  updateSelectedProducts(): void {
    this.selectedProducts = this.labels.flatMap((label) =>
      label.products.concat(
        label.subLabels.flatMap((subLabel) => subLabel.products)
      )
    );
  }
  fetchVendor(params?: {
  offset?: number;
  limit?: number;
  search?: string;
  type?:string
}) {
  this.loadingVendor = true;

  this.apiService.getVendor(params,0).subscribe(
    (res: any[]) => {
      const data = res || [];
      this.vendordata = [...this.vendordata, ...data];

      if (data.length < this.vendorLimit) {
        this.vendorHasMore = false;
      }

      this.vendorOffset += data.length;
      this.loadingVendor = false;
    },
    () => (this.loadingVendor = false)
  );
}
  vendorData() { //qc vendor
    this.apiService.vendorOfQc().subscribe(
      (response) => {
        this.vendordata = response;
        console.log('vendordata', this.vendordata);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  vendorDetails(id: number){
    this.apiService.vendorbranchdetails(id).subscribe(
      (response) => {
        this.vendordetails = response;
        console.log('vendordetails', this.vendordetails);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  vendorBranch(vendor_id: any) {
    this.apiService.getbranch(vendor_id).subscribe(
      (response) => {
        this.selectedBranch = response.data;
        console.log("vendor branch", this.selectedBranch);
      },
      (error) => {
        console.error("Error fetching branch data:", error);
      }
    );
  }

  summary() {
    if (!this.selectedLabel) {
      const newLabel = `${this.labels.length + 1}`;
      this.labels.push({ label: newLabel, products: [{      
        "start_date": "",
        "end_date": "",
        "price": 0,
    }], subLabels: [], level: this.labels.length + 1, type: `item`});
      this.amount.push({ level: newLabel, amount: 0 ,start_date:'',end_date:''})
      console.log('descriptive_product_amount', this.amount);
    } else {
      this.addSummary(this.labels, this.selectedLabel);
    }
    this.flattenLabels();
    this.selectedLabel = null;
  }
  addSummary(labels: any[], targetLabel: string,) {
    for (const label of labels) {
      if (label.level === targetLabel) {
        const newSubLabel = `${label.label}.${label.subLabels.length + 1}`;
        label.subLabels.push({ label: newSubLabel, products: [{      
          "start_date": "",
          "end_date": "",
          "price": 0,
      }], subLabels: [], level: `${label.label}.${label.subLabels.length + 1}`, type: `item`});
        this.amount.push({ level: newSubLabel, amount: 0 ,start_date:'',end_date:''})
        console.log('descriptive_subproduct_amount', this.amount);
      }
      if (label.subLabels && label.subLabels.length > 0) {
        this.addSummary(label.subLabels, targetLabel);
      }
    }
  }

  onAmountUpdated(items: any[]) {
    let total_amount = [];
    let final_dates = [];
    console.log('Updated amount array:', this.amount);

    const lastnode = this.findLastNodes(this.amount);
    console.log(lastnode, "sdasdasda")
    lastnode.forEach((node) => {
      let level = node.level.split('.');
      let amount = node.amount;
      let start_date = node?.start_date ?? '';
      let end_date = node?.end_date ?? '';
      const updatedData = this.generateHierarchyArray(level, amount, start_date, end_date);
      console.log(updatedData, 'dasdasdasdadasdas');
      updatedData.forEach((level_item) => {
        console.log(level_item, "[[[[[[[[[[")
        if (!total_amount[`l${level_item.level}`]) {
          total_amount[`l${level_item.level}`] = 0;
        }

        total_amount[`l${level_item.level}`] += level_item.amount;

        if (!final_dates[`s${level_item.level}`]) {
          final_dates[`s${level_item.level}`] = [];
        }

        if (!final_dates[`e${level_item.level}`]) {
          final_dates[`e${level_item.level}`] = [];
        }

        final_dates[`s${level_item.level}`].push(level_item?.start_date);
        final_dates[`e${level_item.level}`].push(level_item?.end_date);

      })

    })

    for (let target in total_amount) {
      const cleanedTarget = target.replace(/^l/, "");
      for (let i = 0; i < this.amount.length; i++) {
        if (this.amount[i].level === cleanedTarget) {
          const earliestDate = this.findEarliestAndLatestDates(final_dates[`s${cleanedTarget}`]);
          const latestDate = this.findEarliestAndLatestDates(final_dates[`e${cleanedTarget}`]);
          console.log(final_dates[`s${cleanedTarget}`], "sssssss");
          console.log(final_dates[`e${cleanedTarget}`], "eeeeeee");

          this.amount[i].amount = total_amount[target]; // Update the amount
          this.amount[i].start_date = earliestDate.earliest;
          this.amount[i].end_date = latestDate.latest;
        }
      }
    }

    console.log(this.amount, "doneeeeeeeee")
    console.log(final_dates, "datesssssssss")
    this.mergeDataWithLevels(this.labels, this.amount);
    console.log(this.labels, "labelssssssssss")
  }

  mergeDataWithLevels(data: any[], amountArray: any[]): any[] {
    return data.map((item) => {
      // Find the matching level from the amountArray
      const match = amountArray.find((entry) => entry.level == item.level);

      // Update the products within the current item
      if (item.products) {
        item.products = item.products.map((product) => ({
          ...product,
          price: match?.amount || product.price || 0,
          start_date: match?.start_date || product.start_date || "N/A",
          end_date: match?.end_date || product.end_date || "N/A",
        }));
      }
      if (item.type == "item" && match?.amount != 0 && item.subLabels.length == 0) {
        match.amount = 0;
        match.start_date = '';
        match.end_date = '';
      }
      // If the item has subLabels, apply the same logic recursively
      if (item.subLabels) {
        item.subLabels = this.mergeDataWithLevels(item.subLabels, amountArray);
      }

      // Add amount, start_date, and end_date to the current label level
      return {
        ...item,
        price: match?.amount || 0,
        start_date: match?.start_date || "N/A",
        end_date: match?.end_date || "N/A",
      };
    });
  }

  findEarliestAndLatestDates(dates: string[]): { earliest: string | null; latest: string | null } {
    // Filter out invalid dates (empty strings)
    const validDates = dates.filter(date => date.trim() !== '');

    if (validDates.length === 0) {
      // Return null if no valid dates are found
      return { earliest: null, latest: null };
    }

    // Find the earliest and latest dates
    const earliestDate = new Date(Math.min(...validDates.map(date => new Date(date).getTime())));
    const latestDate = new Date(Math.max(...validDates.map(date => new Date(date).getTime())));

    // Format the dates in YYYY-MM-DD format
    return {
      earliest: earliestDate.toISOString().split('T')[0],
      latest: latestDate.toISOString().split('T')[0],
    };
  }

  findLastNodes(data: any) {
    const lastNodes: any[] = [];
    const dates: any[] = []

    data.forEach((node) => {
      console.log(node, "*********")
      const isParent = data.some((other) => other.level.startsWith(`${node.level}.`));
      if (!isParent) {
        lastNodes.push({ "level": node.level, "amount": node.amount, "start_date": node.start_date, "end_date": node.end_date });
      }
    });
    return lastNodes;
  }

  generateHierarchyArray(input: any, amount: any, start_date: any, end_date: any) {
    const result: any[] = [];
    let currentHierarchy = "";
    for (let i = 0; i < input.length - 1; i++) {
      // Build the hierarchy by appending the current number
      currentHierarchy = currentHierarchy ? `${currentHierarchy}.${input[i]}` : `${input[i]}`;
      // result.push({level:currentHierarchy,amount:amount});
      result.push({ level: currentHierarchy, amount: amount, start_date: start_date, end_date: end_date });
    }
    return result;
  }

  updateLevels(data: any[], targetLevel: any) {
    // Filter out the target level and all its children
    const filteredData = data.filter((item) => !item.level.startsWith(targetLevel));

    // Find the target level to replace (e.g., "2" to "1")
    const targetLevelNumber = targetLevel;
    const newBaseLevel = targetLevelNumber + 1;

    // Update the levels of the remaining items
    return filteredData.map((item) => {
      const levelParts = item.level.split(".");
      const topLevel = parseInt(levelParts[0], 10);

      // If the top level matches the target level, adjust it
      if (topLevel >= newBaseLevel) {
        levelParts[0] = `${topLevel - 1}`;
      }
      return {
        ...item,
        level: levelParts.join("."),
      };
    });
  } 


  onToggleChange(event: MatSlideToggleChange) {
    console.log("inside toggle");
    this.vendor = null;
    this.vendor_branch = null;
    this.requisition = [];
    this.quotation = [];
    this.productList = [];
    this.date= null; 
    this.labels=[];
    if (event.checked) {
      this.is_requisition=true;
      this.is_qc=false;
      this.fetchVendor();
      //this.fetchStore();
      //this.fetchrequisition(this.store);
    }else{
      this.is_requisition=false;
      this.is_qc=true;
      this.vendorData();
    }
  }
   getTitle(): string {
      return this.panelTitle;
    }
  
    getFileDetails(files: FileList) {
      for (let i = 0; i < files.length; i++) {
    this.myFiles.push(files[i]);
  }
  console.log('Files for UI:', this.myFiles);
}    

    removeFile(index: number) {
       const removedFile = this.myFiles.splice(index, 1)[0];
          if (this.base64File && removedFile) {
     this.base64File = this.base64File.filter(f => f.name !== removedFile.name);
    }
}
    
      // onFileSelected(event: any) {
      //   this.getFileDetails(event);
      //   const files: FileList = event.target.files;
      //   this.convertFileToBase64(files);
      // }
  onFileSelected(event: any) {
  console.log(event);
  console.log(event.target.files.length);
  const files: FileList = event.target.files;
  if (!files || files.length === 0) return;
  this.getFileDetails(files);

  this.convertFileToBase64(files);
}
  
      openPoFileShowModal() {
        if (this.data.id) {
          this.apiService.getPurchaseOrderFiles(this.data.id).subscribe(
            (response) => {
              this.image_data = response.uploadedFiles; 
              console.log('Data from API:', this.image_data);
      
              this.dialog.open(PurchaseOrderFileModalComponent, {
                width: '1200px',
                    height: '600px',
                data: {  id: this.data.id, images: this.image_data } 
              });
            },
            (error) => {
              console.error("Error fetching images:", error);
            }
          );
        } else {
          console.error("Invalid data ID.");
        }
      }
      
      isImage(extension: string): boolean {
        const imageExtensions = ['jpeg', 'jpg', 'png', 'svg', 'gif'];
        return imageExtensions.includes(extension.toLowerCase());
      }
    
      isDocument(extension: string): boolean {
        const documentExtensions = ['pdf', 'doc', 'docx', 'txt', 'xls', 'xlsx'];
        return documentExtensions.includes(extension.toLowerCase());
      }
    
      convertFileToBase64(files: FileList) {
        this.base64File = this.base64File || [];
        for (let i = 0; i < files?.length; i++) {
        const file = files[i];
        const reader = new FileReader();
       reader.onload = () => {
       const resultAsString = reader.result as string;
         this.base64File.push({ 
        file: resultAsString, 
        name: file.name
        });
      console.log('Base64 Data:', this.base64File);
      };
      reader.onerror = error => {
      console.error('Error reading file:', error);
    };
    reader.readAsDataURL(file);
  }
  }

     
      fetchStore() {
        // this.apiService.getStore().subscribe(
        //   (response) => {
        //     this.store_data = response;
        //     console.log('Store Index:', this.data);
        //   },
        //   (error) => {
        //     console.error('Error fetching data:', error);
        //   }
        // );
      }

      // fetchProfitCost(branch_id: any) {
      // this.profitcost='';
      // this.section=[];
      // this.requisition=[];
      // this.productList=[];
      // this.labels=[];
      //   const postData = {
      //     branch_id: branch_id
      //   };
      //   this.apiService.getProfitCostByBranch(postData).subscribe(
      //     (response) => {
      //       this.profitCost_data = response;
      //       console.log('profit center', this.profitCost_data);
      //       // console.log('selected store inside pc/cc',this.selectedstore)
      //       // if (this.selectedstore) {
      //       //   this.filteredProfitCost = this.profitCost_data.filter(item => {
      //       //     const stores = item.store_id.split(",").map(s => Number(s.trim()));
      //       //     return stores.includes(this.selectedstore);
      //       //   });
      //       // } else {
      //         this.filteredProfitCost = this.profitCost_data;
      //      // }
      //       console.log('filtered profit center', this.filteredProfitCost);
      //     },
      //     (error) => {
      //       console.error('Error fetching data:', error);
      //     }
      //   );
      // }
  onBranchChange(newBranchId: number) {
    console.log('this.previousBranch', this.previousBranch);
    console.log('newBranchId', newBranchId);
    if (this.previousBranch === null) {
      console.log('First load');
      this.previousBranch = newBranchId;
      this.applyBranchChange(newBranchId);
      return;
    }

    if (this.previousBranch === newBranchId) {
      console.log('Same value selected');
      return;
    }
    if (this.isUpdateMode && this.data?.approval_status === 'Open') {
      console.log('Approval Open');
      const skuIds =
        this.productList?.map((p: any) => p.sku_id?.id || p.sku_id).filter(Boolean) || [];

      this.apiService.checkNextDocument({
        doc_id: this.data.id,
        model: 'PurchaseOrder',
        sku_id: skuIds
      }).subscribe((res: any) => {

        if (res.status === false) {
          alert('Next document created. Cannot change branch.');
          this.revertBranch();
        } else {
          this.confirmBranchAndProceed(newBranchId);
        }

      });

      return;
    }
    this.applyBranchChange(newBranchId);
  }
  confirmBranchAndProceed(branchId: number) {
    console.log('Confirm and proceed', branchId);
    const confirmed = confirm(
      'Changing Branch will clear selected data. Do you want to continue?'
    );

    if (!confirmed) {
      this.revertBranch();
      return;
    }

    this.previousBranch = branchId;
    this.applyBranchChange(branchId);
  }

  applyBranchChange(branchId: number) {

    this.resetBranchDependentData();
    this.selectedbranch = branchId;
    this.branch = branchId;
    this.profitCostOffset = 0;
    this.profitCostHasMore = true;
    this.profitCostSearch = '';
    this.filteredProfitCost = [];

    this.fetchProfitCostData();
    // this.apiService.getProfitCostByBranch({ branch_id: branchId }).subscribe(
    //   (response) => {
    //     this.profitCost_data = response;
    //     this.filteredProfitCost = response;
    //   },
    //   (error) => {
    //     console.error('Error fetching profit cost:', error);
    //   }
    // );
  }

  resetBranchDependentData() {
    this.profitcost = '';
    this.section = [];
    this.requisition = [];
    this.productList = [];
    this.labels = [];
  }

  revertBranch() {
    setTimeout(() => {
      this.branch = this.previousBranch;
      this.selectedbranch = this.previousBranch;
    });
  }
      
      allowOnlyNumbers(event: KeyboardEvent): boolean {
        const charCode = event.key;
        if ((charCode >= '0' && charCode <= '9') || charCode === '.') {
          return true;
        }
        event.preventDefault();
        return false;
      }

  //   fetchSection(profit_id:any) {
  //     this.section=[];
  //     this.store='';
  //     this.requisition=[];
  //     this.productList=[];
  //     this.labels=[];
  //    this.fetchStoreData();
  //    this.apiService.getSectionByProfitCost(profit_id).subscribe(
  //     (response) => {
  //       this.section_data = response;
  //         if (this.data?.id) {
  //         this.setSelectedSection(this.sections);
  //       }
  //       console.log('Section data by pc/cc:', this.section_data);
  //     },
  //     (error) => {
  //       console.error('Error fetching data:', error);
  //     }
  //   );
  // } 
  onProfitCostChange(newProfitCostId: number) {
    if (this.previousProfitCost === null) {
      console.log('First load');
      this.previousProfitCost = newProfitCostId;
      this.applyProfitCostChange(newProfitCostId);
      return;
    }
    if (this.previousProfitCost === newProfitCostId) {
      console.log('Same value');
      return;
    }
    if (this.isUpdateMode && this.data?.approval_status === 'Open') {
      console.log('Approval Open');
      const skuIds =
        this.productList?.map((p: any) => p.sku_id?.id || p.sku_id).filter(Boolean) || [];

      this.apiService.checkNextDocument({
        doc_id: this.data.id,
        model: 'PurchaseOrder',
        sku_id: skuIds
      }).subscribe((res: any) => {

        if (res.status === false) {
          alert('Next document created. Cannot change branch.');
          this.revertProfitCost();
        } else {
          this.confirmProfitCostAndProceed(newProfitCostId);
        }
      });
      return;
    }
    this.applyProfitCostChange(newProfitCostId);
  }
  confirmProfitCostAndProceed(profitCostId: number) {
    console.log('Confirm and proceed', profitCostId);
    const confirmed = confirm(
      'Changing Profit/Cost Center will clear selected section, store, requisition and products. Do you want to continue?'
    );
    if (!confirmed) {
      this.revertProfitCost();
      return;
    }
    this.previousProfitCost = profitCostId;
    this.applyProfitCostChange(profitCostId);
  }
  applyProfitCostChange(profitCostId: number) {
    this.resetProfitCostDependentData();
    this.fetchStoreData();
    this.apiService.getSectionByProfitCost(profitCostId).subscribe(
      (response) => {
        this.section_data = response;
        if (this.data?.id) {
          this.setSelectedSection(this.sections);
        }
        console.log('Section data by pc/cc:', this.section_data);
      },
      (error) => {
        console.error('Error fetching sections:', error);
      }
    );
  }
  resetProfitCostDependentData() {
    this.section = [];
    this.store = '';
    this.requisition = [];
    this.productList = [];
    this.labels = [];
  }
  revertProfitCost() {
    setTimeout(() => {
      this.profitcost = this.previousProfitCost;
    });
  }


  setSelectedSection(sectionIds: string) {
    const sectionsIds = sectionIds.split(',').map((id) => +id);
    this.section_ids = sectionsIds,
    this.section = sectionsIds;
  }

   gstMatch(): boolean {
    const selectedBranchData = this.branchdata.find(
      (branch: any) => branch.id === this.branch
    );
    const branchGstFirstTwoDigits =
      selectedBranchData?.gst?.substring(0, 2);

    const selectedVendorBranch = this.selectedBranch.find(
      (vendorBranch: any) => vendorBranch.id === this.vendor_branch
    );
    const vendorBranchGstFirstTwoDigits =
      selectedVendorBranch?.gst_number?.substring(0, 2);

    this.vendorGstType = selectedVendorBranch?.gst_type || '';

    if (!branchGstFirstTwoDigits || !vendorBranchGstFirstTwoDigits) {
      return false;
    }
    return branchGstFirstTwoDigits === vendorBranchGstFirstTwoDigits;
  }

   getCGSTPercentage(gstpercent: number): string | number {
    if (this.vendorGstType === 'UNREGISTERED' || this.vendorGstType === 'NA') return 'NA';
    if (this.vendorGstType === 'SEZ' || this.vendorGstType === 'COMPOSITE') return 0;
    if (!this.gstMatch()) return 0;
    const gstPercentage = gstpercent || 0;
    return gstPercentage / 2;
  }
   getSGSTPercentage(gstpercent: number): string | number {
    if (this.vendorGstType === 'UNREGISTERED' || this.vendorGstType === 'NA') return 'NA';
    if (this.vendorGstType === 'SEZ' || this.vendorGstType === 'COMPOSITE') return 0;
    if (!this.gstMatch()) return 0;
    const gstPercentage = gstpercent || 0;
    return gstPercentage / 2;
  }
   getIGSTPercentage(gstpercent: number): string | number {
    if (this.vendorGstType === 'UNREGISTERED' || this.vendorGstType === 'NA') return 'NA';
    if (this.vendorGstType === 'SEZ' || this.vendorGstType === 'COMPOSITE') return 0;
    if (this.gstMatch()) return 0;
    const gstPercentage = gstpercent || 0;
    return gstPercentage;
  }
   cgstAmount(qty: any, price: any, gst: any) {
    if (this.vendorGstType === 'UNREGISTERED' || this.vendorGstType === 'NA') return 'NA';
    if (this.vendorGstType === 'SEZ' || this.vendorGstType === 'COMPOSITE') return '0.00';
    if (!this.gstMatch()) return '0.00';
    let value = qty * price;
    const taxableValue = value;
    return ((taxableValue * gst) / 2 / 100).toFixed(2);
  }

  sgstAmount(qty: any, price: any, gst: any) {
    if (this.vendorGstType === 'UNREGISTERED' || this.vendorGstType === 'NA') return 'NA';
    if (this.vendorGstType === 'SEZ' || this.vendorGstType === 'COMPOSITE') return '0.00';
    if (!this.gstMatch()) return '0.00';
    let value = qty * price;
    const taxableValue = value;
    return ((taxableValue * gst) / 2 / 100).toFixed(2);
  }

  igstAmount(qty: any, price: any, gst: any) {
    if (this.vendorGstType === 'UNREGISTERED' || this.vendorGstType === 'NA') return 'NA';
    if (this.vendorGstType === 'SEZ' || this.vendorGstType === 'COMPOSITE') return '0.00';
    if (this.gstMatch()) return '0.00';
    let value = qty * price;
    const taxableValue = value;
    return ((taxableValue * gst) / 100).toFixed(2);
  }

  calculateGSTTotals() {
    const gstTotals: { [gstPercent: number]: number } = {};
    const items = Array.isArray(this.labels) ? this.labels : [this.labels];

    const traverse = (node: any) => {
      if (node.products && node.products.length > 0) {
        node.products.forEach((product: any) => {
          const gstPercent = Number(product?.hsn_sac?.gst?.gst_percentage || 0);
          const qty = Number(product.total_qty || 0);
          const unitPrice = Number(product.unit_price || 0);
          const totalPrice = qty * unitPrice;

          if (gstPercent > 0) {
            if (!gstTotals[gstPercent]) gstTotals[gstPercent] = 0;
            gstTotals[gstPercent] += totalPrice;
          }
        });
      }
      if (node.subLabels && node.subLabels.length > 0) {
        node.subLabels.forEach((subLabel: any) => traverse(subLabel));
      }
    };

    items.forEach(item => traverse(item));

    const gstMatch = this.gstMatch();
    const result: any[] = [];

    Object.entries(gstTotals).forEach(([gstPercent, totalPrice]) => {
      const gst = Number(gstPercent);
      const gstAmount = (totalPrice * gst) / 100;

      if (this.vendorGstType === 'UNREGISTERED' || this.vendorGstType === 'NA') {
        result.push({
          gst_percent: gstPercent,
          cgst: 'NA',
          sgst: 'NA',
          igst: 'NA',
        });

      } else if (this.vendorGstType === 'SEZ' || this.vendorGstType === 'COMPOSITE') {
        result.push({
          gst_percent: gst,
          cgst: '0.00',
          sgst: '0.00',
          igst: '0.00'
        });

      } else if (this.vendorGstType === 'REGISTER') {

        if (gstMatch) {
          result.push({
            gst_percent: gst,
            cgst: (gstAmount / 2).toFixed(2),
            sgst: (gstAmount / 2).toFixed(2),
            igst: '0.00'
          });

        } else {
          result.push({
            gst_percent: gst,
            cgst: '0.00',
            sgst: '0.00',
            igst: gstAmount.toFixed(2)
          });
        }
      }
    });

    this.gstSummary = result;
    return result;
  }

  sendForApprove() {

    let category_id:any;
    let category_name:any;
    let price:any;

    const mapAllProducts = (labels: any[]): any[] => {
      let allProducts: any[] = [];
  
      labels.forEach((label) => {
        if (label.products && label.products.length > 0) {
          label.products.forEach((product) => {
            if (!product.stock_keeping?.id) return;
  
            if(this.document_type == "Fixed Asset"){
              category_id = product.fa_template?.home_entity_category?.id;
              category_name = product.fa_template?.home_entity_category?.category_name;
              price = Number(product.price) || 0;
           }else if(this.document_type == "Services"){
            category_id = product.service?.profit_cost_category?.category?.id;
            category_name = product.service?.profit_cost_category?.category?.category_name;
            price = Number(product.price) || 0;
         }else{
              category_id = product.stock_keeping?.profit_cost_category?.category?.id;
              category_name = product.stock_keeping?.profit_cost_category?.category?.category_name;
              price = Number(product.price) || 0;
           }
  
            // check if category already exists
            let existing = allProducts.find(p => p.category_id === category_id);
  
            if (existing) {
              existing.amount += price;
            } else {
              allProducts.push({
                category_id,
                category_name,
                amount: price
              });
            }
          });
        }
  
        // Recursively map subLabels and merge
        if (label.subLabels && label.subLabels.length > 0) {
          const subLabelProducts = mapAllProducts(label.subLabels);
  
          subLabelProducts.forEach(subItem => {
            let existing = allProducts.find(p => p.category_id === subItem.category_id);
            if (existing) {
              existing.amount += subItem.amount;
            } else {
              allProducts.push(subItem);
            }
          });
        }
      });
  
      return allProducts;
    };
  
    this.catagorys = mapAllProducts(this.labels);
    this.category_ids = this.catagorys.map(c => c.category_id);
    console.log('label data', this.labels);
    console.log('category totals', this.catagorys);
     const payload={
        po_id: this.data?.id,
        po_type: this.document_type,
        pc_cc_id:this.profitcost,
        category_ids: this.category_ids,
        date:this.date,
        current_po:this.catagorys,
      }
      console.log('final payload for budget',payload)
          this.apiService.calculateBudget(payload).subscribe((response)=>{
        if(response.status){
        this.calculated_budget = response.data
        console.log('response', response.data);

        const budgetInfo = response.data;
          
          // Check if any category has negative balance
          const negativeBalanceCategories = [];
          for (const categoryKey in budgetInfo) {
            const category = budgetInfo[categoryKey];
            if (category.balance < 0) {
              negativeBalanceCategories.push(category.category_name || categoryKey);
            }
          }

          if (negativeBalanceCategories.length > 0) {
            alert(`Budget exceeded for the following categories: ${negativeBalanceCategories.join(', ')}. Cannot send for approval.`);
            return;
          }


        const requestData = {
          document_type: 'PurchaseOrder',
          document_id: this.data.id,
          profit_cost_id: this.data.profit_cost_id,
          type:this.document_type=="Fixed Asset"?"Goods":this.document_type
        };
        this.apiService.sendForApproval(requestData).subscribe(
          (response) => {
            console.log('Purchase Order sent for approval:', response);
             alert('Document sent for approval');
             this.dialogRef.close({ data: this.data.id, action: 'approvalsend' });
          },
          (error) => {
            console.error('Error sending purchase order for approval:', error);
            alert('Error sending purchase order for approval' + error.error.message);
          }
        );
        }else{
          alert(response.message);
        }
      }, (error) => {
        console.error('Error calculating budget:', error);
      });

  }

  showApprovalTimeline() {
    const requestData = {
      document_type: 'PurchaseOrder',
      document_id: this.data.id,
    };

    this.apiService.getApprovalTimeline(requestData).subscribe(
      (response) => {
        console.log('Approval timeline data:', response);
        
        // Open approval timeline dialog with real data
        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: response.data || response }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      },
      (error) => {
        console.error('Error fetching approval timeline:', error);
        
        // Fallback to demo data if API fails
        const demoApprovalData: ApprovalTimelineData = {
          document_id: this.data.id || 12345,
          document_type: 'Purchase Order',
          current_stage: 2,
          total_stages: 4,
          overall_status: 'pending',
          created_at: new Date().toISOString(),
          created_by: 'Current User',
          stages: [
            {
              id: 1,
              name: 'Department Head Review',
              level: 1,
              status: 'approved',
              approver_name: 'Sarah Johnson',
              approved_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
              comments: 'All requirements met, approved for next level',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 2,
              name: 'Finance Manager Review',
              level: 2,
              status: 'pending',
              is_current: true,
              timeline: [],
              pending_time_seconds: 7200,
              pending_time_formatted: '2h 0m 0s',
              cancellation_count: 0
            },
            {
              id: 3,
              name: 'General Manager Approval',
              level: 3,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 4,
              name: 'Final Approval',
              level: 4,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            }
          ]
        };

        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: demoApprovalData }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      }
    );
  }

  // fetchBranchData() {
  //   this.apiService.getDatabranch().subscribe(
  //     (response) => {
  //       this.branchdata = response;
  //       console.log('Branch data :', this.branchdata);
  //     },
  //     (error) => {
  //       console.error('Error fetching data:', error);
  //     }
  //   );
  // }
  fetchBranchData(params?: {
  offset?: number;
  limit?: number;
  search?: string;
  type?: string;
}) {
  if (params && this.loadingBranch) return;

  if (params) {
    this.loadingBranch = true;
  }
    this.apiService.getDatabranch(params).subscribe(
    (response: any) => {
      const data = Array.isArray(response)
        ? response
        : (response?.branch_data || []);

      if (!params) {
        this.branchdata = data;
        this.loadingBranch = false;
        return;
      }
      this.branchdata = [
        ...this.branchdata,
        ...data
      ];

      if (data.length < (params.limit || this.branchLimit)) {
        this.branchHasMore = false;
      }

      this.branchOffset += data.length;
      this.loadingBranch = false;
    },
    (error) => {
      this.loadingBranch = false;
      console.error('Error fetching branch data:', error);
    }
  );
}

  // onStoreSelect() {
  //   // this.selectedstore = store_id;
  //   // this.branch='';
  //   // this.profitcost='';
  //   // this.section=[];
  //   this.requisition=[];
  //   this.productList=[];
  //   this.labels=[];
  // }
  onStoreSelect(newStoreId: number) {
    if (this.previousStore === null) {
      console.log('First load');
      this.previousStore = newStoreId;
      this.requisition = [];
      this.productList = [];
      this.labels = [];
      return;
    }

    if (this.previousStore === newStoreId) {
      console.log('Same value');
      return;
    }
    if (this.isUpdateMode && this.data?.approval_status === 'Open') {
      console.log('Approval Open');
      const skuIds =
        this.productList?.map((p: any) => p.sku_id?.id || p.sku_id).filter(Boolean) || [];

      this.apiService.checkNextDocument({
        doc_id: this.data.id,
        model: 'PurchaseOrder',
        sku_id: skuIds
      }).subscribe((res: any) => {

        if (res.status === false) {
          alert('Next document created. Cannot change branch.');
          setTimeout(() => {
            this.store = this.previousStore;
          });
        } else {
          this.confirmStoreAndProceed(newStoreId);
        }

      });

      return;
    }
    // this.confirmStoreAndProceed(newStoreId);
  }
  confirmStoreAndProceed(storeId: number) {
    console.log('Confirm and proceed', storeId);
    const confirmed = confirm(
      'Changing Store will clear selected section, store, requisition and products. Do you want to continue?'
    );
    if (!confirmed) {
      setTimeout(() => {
        this.store = this.previousStore;
      });
      return;
    }
    this.previousStore = storeId;
    this.requisition = [];
    this.productList = [];
    this.labels = [];
  }
  // onStoreSelect() {
  //   // this.selectedstore = store_id;
  //   // this.branch='';
  //   // this.profitcost='';
  //   // this.section=[];
  //   this.requisition=[];
  //   this.productList=[];
  //   this.labels=[];
  // }
    fetchStoreData() {
    const postData = {
      profit_cost_id: this.profitcost,
    };
    console.log('profit cost id',postData);
    this.apiService.getStoreByPcCc(postData).subscribe(
      (response) => {
        this.store_data = response;
        console.log('store data',this.store_data);
        // if (this.data?.id) {
        //   this.store = this.selectedstore;
        //   console.log('store data html', this.store );
        // }
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  viewRelatedDocuments(purchaseOrderId: number): void {
    const payload = {
      document_id: purchaseOrderId,
      document_type: "purchase_order"
    };

    // Show loading state
    const loadingDialog = this.dialog.open(DocumentTracingModalComponent, {
      width: '90%',
      maxWidth: '1200px',
      height: '80%',
      maxHeight: '800px',
      disableClose: false,
      data: {
        tracingData: null,
        loading: true
      }
    });

    this.apiService.getDocumentTracing(payload).subscribe(
      (response) => {
        if (response.status) {
          // Close loading dialog and open with data
          loadingDialog.close();

          const dialogRef = this.dialog.open(DocumentTracingModalComponent, {
            width: '90%',
            maxWidth: '1200px',
            height: '80%',
            maxHeight: '800px',
            disableClose: false,
            data: {
              tracingData: {
                ...response.data,
                document_type: "purchase_order",
                current_document: response.data.current_document || `PO${purchaseOrderId}` // Ensure current document is set
              },
              loading: false
            }
          });

          dialogRef.afterClosed().subscribe(() => {
            console.log('Document tracing modal closed');
          });
        } else {
          loadingDialog.close();
          alert('Error: ' + response.message);
        }
      },
      (error) => {
        loadingDialog.close();
        console.error('Error fetching document tracing:', error);

        let errorMessage = 'Error fetching related documents. Please try again.';
        if (error.error && error.error.message) {
          errorMessage = error.error.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        alert(errorMessage);
      }
    );
  }  

  calculateBudget() {
    let category_id:any;
    let category_name:any;
    let price:any;
    const mapAllProducts = (labels: any[]): any[] => {
      let allProducts: any[] = [];
      console.log('labels_budget',labels);
      console.log('document_type',this.document_type);
  
      labels.forEach((label) => {
        if (label.products && label.products.length > 0) {
          label.products.forEach((product) => {
            if (!product.stock_keeping?.id && !product.fa_template?.id) return;

            if(this.document_type == "Fixed Asset"){
               category_id = product.fa_template?.home_entity_category?.id;
               category_name = product.fa_template?.home_entity_category?.category_name;
               price = Number(product.price) || 0;
            }else if(this.document_type == "Services"){
               category_id = product.service?.profit_cost_category?.category?.id;
               category_name = product.service?.profit_cost_category?.category?.category_name;
               price = Number(product.price) || 0;
            }
            else{
               category_id = product.stock_keeping?.profit_cost_category?.category?.id;
               category_name = product.stock_keeping?.profit_cost_category?.category?.category_name;
               price = Number(product.price) || 0;
            }
  
           
  
            // check if category already exists
            let existing = allProducts.find(p => p.category_id === category_id);
  
            if (existing) {
              existing.amount += price;
            } else {
              allProducts.push({
                category_id,
                category_name,
                amount: price
              });
            }
          });
        }
  
        // Recursively map subLabels and merge
        if (label.subLabels && label.subLabels.length > 0) {
          const subLabelProducts = mapAllProducts(label.subLabels);
  
          subLabelProducts.forEach(subItem => {
            let existing = allProducts.find(p => p.category_id === subItem.category_id);
            if (existing) {
              existing.amount += subItem.amount;
            } else {
              allProducts.push(subItem);
            }
          });
        }
      });
  
      return allProducts;
    };
  
    this.catagorys = mapAllProducts(this.labels);
    this.category_ids = this.catagorys.map(c => c.category_id);
    console.log('label data', this.labels);
    console.log('category totals', this.catagorys);
     const payload={
        po_id: this.data?.id,
        po_type: this.document_type,
        pc_cc_id:this.profitcost,
        category_ids: this.category_ids,
        date:this.date,
        current_po:this.catagorys,
      }
      console.log('final payload for budget',payload)
          this.apiService.calculateBudget(payload).subscribe((response)=>{
        if(response.status){
        this.calculated_budget = response.data
        console.log('response', response.data);
        }else{
          alert(response.message);
        }
      }, (error) => {
        console.error('Error calculating budget:', error);
      });
  }
  onVendorOpen(opened: boolean) {
  if (!opened) return;

  this.vendordata = [];
  this.vendorOffset = 0;
  this.vendorHasMore = true;
  this.vendorSearch = '';

  this.fetchVendor({
    offset: this.vendorOffset,
    limit: this.vendorLimit,
    type:'lazyloading'
  });

  Promise.resolve().then(() => {
    const panel = this.vendorSelect.panel?.nativeElement;
    if (!panel) return;

    panel.removeEventListener('scroll', this.onVendorScroll);
    panel.addEventListener('scroll', this.onVendorScroll);
  });
}
onVendorScroll = (event: any) => {
  const panel = event.target as HTMLElement;

  if (
    panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 20 &&
    this.vendorHasMore &&
    !this.loadingVendor
  ) {
    this.fetchVendor({
      offset: this.vendorOffset,
      limit: this.vendorLimit,
      search: this.vendorSearch,
      type:'lazyloading'
    });
  }
};
onVendorSearch(value: string) {
  this.vendorSearch = value || '';
  this.vendorOffset = 0;
  this.vendorHasMore = true;
  this.vendordata = [];

  this.fetchVendor({
    offset: this.vendorOffset,
    limit: this.vendorLimit,
    search: this.vendorSearch,
    type:'lazyloading'
  });
}
onBranchOpen(opened: boolean) {
  if (!opened) return;
  this.branchOffset = 0;
  this.branchHasMore = true;
  this.branchSearch = '';

  this.fetchBranchData({
    offset: this.branchOffset,
    limit: this.branchLimit,
    type:'lazyloading'
  });

  Promise.resolve().then(() => {
    const panel = this.branchSelect.panel?.nativeElement;
    if (!panel) return;

    panel.removeEventListener('scroll', this.onBranchScroll);
    panel.addEventListener('scroll', this.onBranchScroll);
  });
}
onBranchScroll = (event: any) => {
  const panel = event.target as HTMLElement;

  if (
    panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 20 &&
    this.branchHasMore &&
    !this.loadingBranch
  ) {
    this.fetchBranchData({
      offset: this.branchOffset,
      limit: this.branchLimit,
      search: this.branchSearch,
      type:'lazyloading'
    });
  }
};
onBranchSearch(value: string) {
  this.branchSearch = value || '';
  this.branchOffset = 0;
  this.branchHasMore = true;
  this.branchdata = [];

  this.fetchBranchData({
    offset: this.branchOffset,
    limit: this.branchLimit,
    search: this.branchSearch,
    type:'lazyloading'
  });
}
getVendorName(vendorId: number): string {
  const vendor = this.vendordata.find(v => v.id === vendorId);
  return vendor ? vendor.vendor_name : 'Unknown Vendor';
}
getBranchName(branchId: number): string {
  const branch = this.branchdata.find(b => b.id === branchId);
  return branch ? branch.name : 'Unknown Branch';  
}

deleteSubLabel(subLabel: any) {
    console.log('deleteSubLabel', subLabel);
    // Remove the exact level and any descendants (e.g. "2.1" and "2.1.1", "2.1.2"...)
    // for (let i = this.amount.length - 1; i >= 0; i--) {
    //   const level = this.amount[i]?.level;
    //   if (level === subLabel.level || (typeof level === 'string' && level.startsWith(subLabel.level + '.'))) {
    //     this.amount.splice(i, 1);
    //   }
    // }
    this.on_delete_amount(subLabel.level);
    // 2. Remove from labels tree and trigger renumbering
    this.removeAndRenumber(this.labels, subLabel);
    // 3. Update other states
    this.updateSelectedProducts();
    this.flattenLabels();
    this.calculateGSTTotals();
  }

  removeAndRenumber(labels: any[], targetLabel: any, parentLevel: string = ''): boolean {
    const index = labels.indexOf(targetLabel);
    if (index !== -1) {
      // Found it in this array
      labels.splice(index, 1);
      // Renumber this array starting from 0 (all siblings)
      this.renumberItems(labels, parentLevel);
      return true;
    }
    // Not found, look in children
    for (const label of labels) {
      if (label.subLabels && label.subLabels.length > 0) {
        if (this.removeAndRenumber(label.subLabels, targetLabel, label.level)) {
          return true;
        }
      }
    }
    return false;
  }

  renumberItems(items: any[], parentLevel: string) {
    items.forEach((item, index) => {
      const newLevel = parentLevel ? `${parentLevel}.${index + 1}` : `${index + 1}`;
      // Update level if it changed
      if (item.level !== newLevel) {
        this.updateAmountLevel(item.level, newLevel);
        item.level = newLevel;
        item.label = newLevel;
      }
      // Always recurse to maintain consistency for nested items
      if (item.subLabels && item.subLabels.length > 0) {
        this.renumberItems(item.subLabels, newLevel);
      }
    });
  }

  updateAmountLevel(oldLevel: string, newLevel: string) {
    // Find exact match in amount array and update it
    const amt = this.amount.find(a => a.level === oldLevel);
    if (amt) {
      amt.level = newLevel;
    }
  }

  check_label_amount() {
    console.log("labelssssssssssss", this.labels);
    console.log("amountttttttttt", this.amount);
    // Force running the same aggregation logic that runs on amount.push
    // This will recompute hierarchy totals/dates based on current this.amount
    this.onAmountUpdated([]);
  }

  // on_delete_amount(delete_level:any){
  //   for (let i = this.amount.length - 1; i >= 0; i--) {
  //     const level = this.amount[i]?.level;
  //     console.log( "levelsssssssss",level);
  //     console.log( "delete_levelddddddd",delete_level);
  //     console.log( "level.startsWith(delete_level + '.')",level?.startsWith(delete_level + '.'));
  //     if (level == delete_level || (level.startsWith(delete_level + '.'))) {
  //       console.log( "levelsssssssss inside if",level);
  //     console.log( "delete_levelddddddd inside if",delete_level);
  //     console.log("level.startsWith(delete_level + '.') inside if",level?.startsWith(delete_level + '.'));
  //       this.amount.splice(i, 1);
  //     }
  //   }
  // }


  on_delete_amount(deleteLevel: any) {
    deleteLevel = String(deleteLevel);
    const parts = deleteLevel.split('.');
    const deletedIndex = Number(parts[parts.length - 1]);
    const parentPrefix = parts.slice(0, -1).join('.'); // "" | "1" | "1.2"
    /* ---------------- STEP 1: REMOVE SUBTREE (IN-PLACE) ---------------- */
    for (let i = this.amount.length - 1; i >= 0; i--) {
      const level = this.amount[i].level;
      if (level == deleteLevel || level.startsWith(deleteLevel + '.')) {
        this.amount.splice(i, 1);
      }
    }
    /* ---------------- STEP 2: RENNUMBER REMAINING LEVELS ---------------- */
    for (let i = 0; i < this.amount.length; i++) {
      const item = this.amount[i];
      const levelParts = item.level.split('.');
      // CASE A → same depth sibling shift
      if (levelParts.length == parts.length) {
        const itemParent = levelParts.slice(0, -1).join('.');
        const itemIndex = Number(levelParts[levelParts.length - 1]);
        if (itemParent === parentPrefix && itemIndex > deletedIndex) {
          levelParts[levelParts.length - 1] = String(itemIndex - 1);
          item.level = levelParts.join('.');
          continue;
        }
      }
      // CASE B → deeper children prefix shift
      const oldPrefix =
        (parentPrefix ? parentPrefix + '.' : '') + (deletedIndex + 1);
      if (item.level.startsWith(oldPrefix + '.')) {
        const newPrefix =
          (parentPrefix ? parentPrefix + '.' : '') + deletedIndex;
        item.level = item.level.replace(oldPrefix, newPrefix);
      }
    }
  }
  fetchProfitCostData() {
  if (this.loadingProfitCost || !this.profitCostHasMore) {
    return;
  }

  this.loadingProfitCost = true;

  const postData = {
    branch_id: this.branch,
    offset: this.profitCostOffset,
    limit: this.profitCostLimit,
    search: this.profitCostSearch || undefined
  };

  this.apiService.getProfitCostByBranch(postData).subscribe(
    (response) => {

      const data = response?.data ?? response ?? [];

      if (this.profitCostOffset === 0) {
        this.filteredProfitCost = data;
      } else {
        this.filteredProfitCost = [
          ...this.filteredProfitCost,
          ...data
        ];
      }
      this.profitCostOffset += data.length;
      this.profitCostHasMore = data.length >= this.profitCostLimit;
      this.loadingProfitCost = false;
    },
    (error) => {
      console.error('Error fetching profit cost:', error);
      this.loadingProfitCost = false;
    }
  );
}
onProfitCostSearch(search: string) {
  this.profitCostSearch = search;
  this.profitCostOffset = 0;
  this.profitCostHasMore = true;
  this.filteredProfitCost = [];

  this.fetchProfitCostData();
}

  get isInputDisabled(): boolean {
    return this.panelMode === 'view';
  }

  private initPanelMode(): void {
    const t = (this.types || '').toLowerCase();
    if (t === 'view') {
      this.panelMode = 'view';
      this.isView = true;
      this.isUpdateMode = true;
    } else if (t === 'create') {
      this.panelMode = 'create';
      this.isView = false;
      this.isUpdateMode = false;
    } else {
      this.panelMode = 'edit';
      this.isView = false;
      if (this.data?.id) this.isUpdateMode = true;
    }
  }

  get panelTitle(): string {
    if (this.is_reverse) return 'Reverse Purchase Order';
    switch (this.panelMode) {
      case 'create': return 'Create Purchase Order';
      case 'edit': return 'Edit Purchase Order';
      case 'view': return 'View Purchase Order';
      default: return 'Purchase Order';
    }
  }

  get statusLabel(): string {
    if (!this.data?.id) return 'Draft';
    return this.data.approval_status || 'Open';
  }

  get statusVariant(): UiBadgeVariant {
    const status = this.data?.approval_status;
    if (!this.data?.id || status == null || status === 'Open') return 'default';
    if (status === 'Approved') return 'approved';
    if (status === 'Pending') return 'pending';
    if (status === 'Rejected') return 'rejected';
    return 'default';
  }

  get approvalSteps(): UiApprovalStep[] {
    const status = this.data?.approval_status;
    const steps: UiApprovalStep[] = [
      { id: 'draft', label: 'Draft', icon: 'edit_note', state: 'upcoming' },
      { id: 'pending', label: 'Pending Approval', icon: 'schedule', state: 'upcoming' },
      { id: 'approved', label: 'Approved', icon: 'check_circle', state: 'upcoming' },
    ];
    if (!this.data?.id) { steps[0].state = 'active'; return steps; }
    if (status == null || status === 'Open') steps[0].state = 'active';
    else if (status === 'Pending') { steps[0].state = 'completed'; steps[1].state = 'active'; }
    else if (status === 'Approved') { steps[0].state = 'completed'; steps[1].state = 'completed'; steps[2].state = 'completed'; }
    else if (status === 'Rejected') { steps[0].state = 'completed'; steps[1].state = 'rejected'; }
    return steps;
  }

  canEdit(): boolean {
    if (this.is_reverse) return false;
    const status = this.data?.approval_status;
    return status == null || status === 'Open' || status === 'Rejected';
  }

  enterEditMode(): void {
    if (!this.canEdit()) return;
    this.enteredEditFromView = true;
    this.panelMode = 'edit';
    this.isView = false;
    this.isUpdateMode = true;
    this.types = 'update';
    this.editSnapshot = this.captureEditSnapshot();
  }

  enterViewMode(): void {
    this.panelMode = 'view';
    this.isView = true;
    this.isUpdateMode = true;
    this.types = 'view';
    this.enteredEditFromView = false;
    this.editSnapshot = null;
  }

  private captureEditSnapshot(): string {
    return JSON.stringify({
      remark: this.remark, date: this.date, vendor: this.vendor, branch: this.branch,
      vendor_branch: this.vendor_branch, profitcost: this.profitcost, section: this.section,
      store: this.store, document_type: this.document_type, labels: this.labels,
      contact_type_id: this.contact_type_id,
    });
  }

  hasUnsavedChanges(): boolean {
    if (this.panelMode !== 'edit' || !this.editSnapshot) return false;
    return this.captureEditSnapshot() !== this.editSnapshot;
  }

  private restoreFromSnapshot(): void {
    if (!this.editSnapshot) return;
    const s = JSON.parse(this.editSnapshot);
    this.remark = s.remark;
    this.date = s.date;
    this.vendor = s.vendor;
    this.branch = s.branch;
    this.vendor_branch = s.vendor_branch;
    this.profitcost = s.profitcost;
    this.section = s.section;
    this.store = s.store;
    this.document_type = s.document_type;
    this.labels = s.labels;
    this.contact_type_id = s.contact_type_id;
  }

  onClose(): void { this.handleExitIntent('close'); }
  onCancel(): void {
    if (this.panelMode === 'edit' && this.enteredEditFromView) {
      this.handleExitIntent('view');
      return;
    }
    this.handleExitIntent('close');
  }

  private handleExitIntent(intent: 'close' | 'view'): void {
    if (this.panelMode === 'edit' && this.hasUnsavedChanges()) {
      this.promptUnsavedChanges(intent);
      return;
    }
    this.executeExitIntent(intent);
  }

  private executeExitIntent(intent: 'close' | 'view'): void {
    if (intent === 'view') this.enterViewMode();
    else this.dialogRef.close();
  }

  private promptUnsavedChanges(intent: 'close' | 'view'): void {
    const promptRef = this.dialog.open(UiUnsavedChangesDialogComponent, {
      width: '440px', disableClose: true, panelClass: 'ui-unsaved-changes-dialog',
    });
    promptRef.afterClosed().subscribe((result: UnsavedChangesResult | undefined) => {
      if (!result || result === 'cancel') return;
      if (result === 'discard') { this.restoreFromSnapshot(); this.executeExitIntent(intent); return; }
      if (result === 'save') this.save(intent);
    });
  }

  get footerPrimaryActions(): UiPanelAction[] {
    if (this.panelMode === 'view') {
      return this.canEdit() ? [{ id: 'edit', label: 'Edit', icon: 'edit', variant: 'primary', visible: true }] : [];
    }
    return [
      { id: 'save', label: 'Save', icon: 'save', variant: 'success', visible: !this.isInputDisabled },
      { id: 'calculate', label: 'Calculate', icon: 'calculate', variant: 'warning', visible: true },
      { id: 'send-approval', label: 'Send for Approval', icon: 'send', variant: 'primary',
        visible: !!this.data?.id && this.canEdit() && !this.is_reverse },
    ];
  }

  get footerSecondaryActions(): UiPanelAction[] {
    return [
      { id: 'tracing', label: 'Document Tracing', icon: 'account_tree', variant: 'outline',
        visible: !!this.data?.id && this.panelMode !== 'view' },
      { id: 'timeline', label: 'Approval Timeline', icon: 'timeline', variant: 'outline',
        visible: !!this.data?.id && ['Pending','Rejected','Approved'].includes(this.data.approval_status) && this.panelMode !== 'view' },
      { id: 'cancel', label: this.panelMode === 'view' ? 'Close' : 'Cancel', icon: 'close', variant: 'ghost', visible: true },
    ];
  }

  get footerDestructiveAction(): UiPanelAction | null {
    const status = this.data.approval_status;
    if (this.panelMode !== 'view' || !this.data?.id|| status === 'Approved' || status === 'Pending') return null;
    return { id: 'delete', label: 'Delete', icon: 'delete', variant: 'danger', visible: true };
  }

  get footerOverflowActions(): UiPanelAction[] {
    if (this.panelMode !== 'view' || !this.data?.id) return [];
    const status = this.data.approval_status;
    return [
      { id: 'tracing', label: 'Document Tracing', icon: 'account_tree', visible: true },
      { id: 'timeline', label: 'Approval Timeline', icon: 'timeline',
        visible: ['Pending','Rejected','Approved'].includes(status) },
      { id: 'preview', label: 'Preview PDF', icon: 'picture_as_pdf', visible: true },
      { id: 'archive', label: 'Archive', icon: 'archive', visible: true },
      { id: 'short-close', label: 'Short Close', icon: 'block', visible: status === 'Approved' && this.data?.short_close != 1 && !this.is_short_close },
      { id: 'reopen', label: 'Reopen', icon: 'replay', visible: status === 'Approved' && this.data?.short_close != 1 && !this.is_short_close },
      { id: 'cancel-approval', label: 'Cancel Approval', icon: 'cancel', visible: status === 'Pending'},
      { id: 'reverse', label: 'Reverse', icon: 'undo', visible: status === 'Approved' && !this.is_reverse },
    ];
  }

  is_short_close = false;

  onFooterAction(actionId: string): void {
    switch (actionId) {
      case 'save': this.save('close'); break;
      case 'calculate': this.calculateBudget(); break;
      case 'send-approval': this.sendForApprove(); break;
      case 'tracing': if (this.data?.id) this.viewRelatedDocuments(this.data.id); break;
      case 'timeline': this.showApprovalTimeline(); break;
      case 'edit': this.enterEditMode(); break;
      case 'delete': this.deletePo(); break;
      case 'preview': this.previewPdf(); break;
      case 'archive': this.openArchive(); break;
      case 'short-close': this.shortClosePo(); break;
      case 'reopen': this.onReopen(); break;
      case 'cancel-approval': this.onCancelApproval(); break;
      case 'reverse': this.openReverseMode(); break;
      case 'cancel': this.onCancel(); break;
    }
  }

  deletePo(): void {
    if (!this.data?.id) return;
    const skuIds =   this.productList?.flatMap((product: any) => product.requisitiondetials || [])
  .map((detail: any) => detail.sku_id?.id || detail.sku_id)
  .filter(Boolean) || [];
    console.log('delete sku',skuIds);

    this.apiService.checkNextDocument({
      doc_id: this.data.id,
      model: 'PurchaseOrder',
      sku_id: skuIds,
      type: 'delete'
    }).subscribe((res: any) => {
      if (res.status === false) {
        alert(res.message);
        return;
      } else {
         if (confirm('Are you sure you want to delete this Purchase Order?')) {
          this.apiService.deletepo(this.data.id).subscribe(
            (response) => { 
              alert(response.message); 
              this.dialogRef.close({ id: this.data.id, action: 'delete' }); 
            },
            (error) => alert(error.error?.message)
          );
        }
      }
    });
  }

  shortClosePo(): void {
    if (!this.data?.id) return;
     const skuIds =   this.productList?.flatMap((product: any) => product.requisitiondetials || [])
  .map((detail: any) => detail.sku_id?.id || detail.sku_id)
  .filter(Boolean) || [];
    console.log('short close po sku',skuIds);

    this.apiService.checkNextDocument({
      doc_id: this.data.id,
      model: 'PurchaseOrder',
      sku_id: skuIds,
      type: 'short_close'
    }).subscribe((res: any) => {
      if (res.status) {
       alert(res.message);
        if (confirm('Do you want to short close this document?')) {
          console.log("short close po",this.data);
          const payload = { po_id: this.data.id, type: 'short_close' };
          this.apiService.poShortClose(payload).subscribe(
            (response) => { 
              alert(response.message); 
              this.dialogRef.close({ id: this.data.id, action: 'short_close' }); 
            },
            (error) => alert(error.error?.message)
          );
        }
      }
  
  });
}

  openArchive(): void {
    if (!this.data?.id) return;
    this.dialog.open(PurchaseOrderArchiveComponent, {
      width: '90vw', height: '90vh', maxWidth: '90vw', maxHeight: '90vh',
      panelClass: 'ui-document-panel', disableClose: true, data: { id: this.data.id },
    });
  }

  previewPdf(): void {
    if (!this.data?.id) return;
    const postData = {
      po_id: this.data.id,
      domain: this.hostname,
      fulldomain: this.fullhostname,
      approval_status: this.data.approval_status,
    };
    this.apiService.popdfdata(postData).subscribe(
      (response) => {
        this.apiService.popreview(response).subscribe((pdfResponse) => {
          const downloadUrl = pdfResponse[0];
          const fileName = downloadUrl.split('/').pop() || 'PurchaseOrder.pdf';
          const downloadLink = document.createElement('a');
          downloadLink.href = downloadUrl;
          //downloadLink.target = '_blank';
          downloadLink.download = fileName; 
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        });
      },
      (error) => console.error('Error fetching PDF:', error)
    );
  }

  onReopen(): void {
    if (!this.data?.id) return;
    const postData = { doc_id: this.data.id, model: 'PurchaseOrder', type: 'reopen' };
    if (confirm('Do you want to reopen this document?')) {
    this.apiService.checkNextDocument(postData).subscribe({
      next: (res: any) => {
        if (res.status === true) {
          this.types = 'reopen';
          this.panelMode = 'edit';
          this.isView = false;
          this.data.approval_status = 'Open';
        } else {
          alert(res.message);
        }
      },
      error: () => alert('Something went wrong!'),
    });
    } else {
      return;
    }
  }
  onCancelApproval(): void {
    if (!this.data?.id) return;
       if (confirm('Do you want to cancel approval for this document?')) {
          this.cancelApprovalService.cancelApproval(this.data.id, 'PurchaseOrder', () => {
            this.data.approval_status = 'Open';
            this.enterViewMode();
          });
       }
  }

  openReverseMode(): void {
    if (!this.data?.id) return;
    this.is_reverse = true;
    this.panelMode = 'edit';
    this.isView = false;
    this.types = 'reverse';
    this.editSnapshot = this.captureEditSnapshot();
  }
  preventTyping(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      return;
    }
    event.preventDefault();
  }
}
